import { render, staticRenderFns } from "./DrugOrderItemsRelocationEditDlg.vue?vue&type=template&id=65a64674&"
import script from "./DrugOrderItemsRelocationEditDlg.vue?vue&type=script&lang=js&"
export * from "./DrugOrderItemsRelocationEditDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports